// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 722 ? "Seller" : chunkId) + "." + {"94":"32e1f36e","160":"7f9e4fe7","722":"7f9e4fe7","767":"7f9e4fe7","894":"c43ee70e"}[chunkId] + ".chunk.css";
};